const aaa = [
    // 门店预约 预约排班  预约配置
    {
      path: "yuyueShop",
      component: () => import("@/views/yuyue/yuyueShop/yuyueShop.vue"),
      meta: { title: "门店预约" },
    },
    // 排班
    {
      path: "yuyuePaiBan",
      component: () => import("@/views/yuyue/yuyuePaiBan/yuyuePaiBan.vue"),
      meta: { title: "预约排班" },
    },

  
    {
      path: "petShuttle",
      component: () => import("@/views/yuyue/petShuttle/petShuttle.vue"),
      meta: { title: "宠物接送", keepAlive: true },
    },
  ];
  export default aaa;
  